import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider, createBrowserRouter } from 'react-router-dom'

import { ErrorApi } from './api/cliente'
import { Armazon } from './App'
import './index.css'
import { LimiteDeError, NoEncontrado } from './paginas/Error'
import { Inicio } from './paginas/Inicio'
import { Login } from './paginas/Login'
import { Registro } from './paginas/Registro'
import { Workspace } from './paginas/Workspace'
import { ProveedorAvisos } from './ui/avisos'

const cache = new QueryClient({
  defaultOptions: {
    queries: {
      // Reintentar un 400 o un 404 no arregla nada; un 5xx o un corte de red sí.
      retry: (intento, error) =>
        error instanceof ErrorApi ? error.esReintentable && intento < 2 : intento < 2,
      staleTime: 15_000,
      refetchOnWindowFocus: false,
    },
  },
})

const router = createBrowserRouter([
  // Login y registro van fuera del armazón: no tienen cabecera ni exigen
  // sesión, que es justo lo que el armazón impone.
  { path: '/login', element: <Login /> },
  { path: '/registro', element: <Registro /> },
  {
    element: <Armazon />,
    children: [
      { path: '/', element: <Inicio /> },
      { path: '/entidad/:id', element: <Workspace /> },
      { path: '/entidad/:id/:pestana', element: <Workspace /> },
      // El catch-all de Django sirve la app en cualquier ruta, así que el
      // router necesita su propio comodín o la página queda en blanco.
      { path: '*', element: <NoEncontrado /> },
    ],
  },
])

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={cache}>
      <LimiteDeError>
        <ProveedorAvisos>
          <RouterProvider router={router} />
        </ProveedorAvisos>
      </LimiteDeError>
    </QueryClientProvider>
  </StrictMode>,
)
